import { SHTypography } from "@components/design-systems";
import { Link, useTheme } from "@mui/material";

type Props = {
  actionType: "create" | "edit" | "duplicate";
  analysisType?: "Platform Analyses" | "Suitability Reviews";
  onNavigate?: () => void;
};

export const AnalysisUpgradeToModifyNotification = ({
  actionType,
  analysisType = "Suitability Reviews",
  onNavigate,
}: Props) => {
  const { palette } = useTheme();

  return (
    <SHTypography color={palette.text.white}>
      Upgrade your subscription
      <Link
        variant="body2"
        component="a"
        underline="always"
        color={palette.text.white}
        onClick={() => onNavigate?.()}
        sx={{
          paddingX: 0.5,
          cursor: "pointer",
          textDecorationColor: palette.text.white,
        }}
      >
        here
      </Link>
      to {actionType} {analysisType}.
    </SHTypography>
  );
};
